import { Component, forwardRef, Input, OnInit } from '@angular/core';
import {
    AbstractControl,
    FormControl,
    NG_VALUE_ACCESSOR,
    ValidatorFn,
    Validators,
    FormsModule,
    ReactiveFormsModule,
} from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { ValidationErrorsComponent } from '../validation-errors/validation-errors.component';
import { InputTextModule } from 'primeng/inputtext';

@Component({
    selector: 'app-phone-field',
    templateUrl: './phone-field.component.html',
    styleUrls: ['./phone-field.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => PhoneFieldComponent),
            multi: true,
        },
    ],
    standalone: true,
    imports: [FormsModule, InputTextModule, ReactiveFormsModule, ValidationErrorsComponent],
})
export class PhoneFieldComponent implements OnInit {
    @Input() name!: string;
    @Input() readonly!: string;
    @Input() horizontal!: boolean;
    @Input() width!: number;
    @Input() maxlength = 30;
    @Input() disabled = false;
    @Input() hideLabel = false;
    @Input() required = false;

    formControl: FormControl = new FormControl();

    constructor(private translate: TranslateService) {}

    ngOnInit() {
        if (this.required) {
            this.formControl.addValidators(Validators.required);
        }

        if (this.maxlength) {
            this.formControl.addValidators(Validators.maxLength(this.maxlength));
        }

        if (this.disabled) {
            this.formControl.disable();
        }

        /*this.formControl.addValidators([Validators.pattern(/^([0|+[0-9]{1,5})?([7-9][0-9]{9})$/)]);*/
        this.formControl.addValidators([this.customPatternValidator(/^([0|+[0-9]{1,5})?([7-9][0-9]{9})$/)]);
    }

    private customPatternValidator(regex: RegExp): ValidatorFn {
        return (control: AbstractControl): { [key: string]: any } | null => {
            if (control.value && !regex.test(control.value)) {
                return { customPattern: this.translate.instant('label.phoneIsInvalidFormat') };
            }
            return null;
        };
    }

    writeValue(value: any) {
        this.formControl.setValue(value);
    }

    registerOnChange(fn: Function) {
        this.formControl.valueChanges.subscribe((val) => fn(val));
    }

    registerOnTouched(fn: Function) {
        this.formControl.valueChanges.subscribe((val) => fn(val));
    }

    getFieldLabel(): string {
        if (this.hideLabel) {
            return '';
        } else {
            return this.translate.instant(this.name ? 'field.' + this.name : '').toString();
        }
    }
}
